import { connect } from 'react-redux'
import Map from './Map'
import { onExtentChange } from '../../actionCreators'

const mapStateToProps = (state, ownProps) => ({
	center: state.mapView.center,
	zoom: state.mapView.zoom,
	basemap: state.basemap
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	onExtentChange: (event) => dispatch(onExtentChange(event.bounds, event.view))
})

export default connect(mapStateToProps, mapDispatchToProps)(Map)



// WEBPACK FOOTER //
// ./src/components/Map/MapContainer.js